import { render, staticRenderFns } from "./Directors.vue?vue&type=template&id=59b76df8"
import script from "./Directors.vue?vue&type=script&lang=js"
export * from "./Directors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports